import { PayeeBindingTypesEnum } from '@root/api/ump-catalog-manager'
import { Binding } from '@root/api/ump-plat-sdk-gateway'

export const getMtsBinding = (bindings: Binding[]) =>
  bindings?.find((item) => item.bindingType === PayeeBindingTypesEnum.MTSACCOUNT)
